export type ScopeTone = 'violet' | 'blue' | 'pink' | 'green' | 'orange';

export interface ScopeTheme {
  tone: ScopeTone;
  accentVar: string;
}

const TONES: ReadonlyArray<ScopeTone> = ['violet', 'blue', 'pink', 'green', 'orange'];

const ACCENT_VAR: Record<ScopeTone, string> = {
  violet: 'var(--c-violet)',
  blue: 'var(--c-blue)',
  pink: 'var(--c-pink)',
  green: 'var(--c-green)',
  orange: 'var(--c-orange)',
};

export function themeForScope(name: string): ScopeTheme {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) | 0;
  const tone = TONES[Math.abs(hash) % TONES.length]!;
  return { tone, accentVar: ACCENT_VAR[tone] };
}
